import { gql } from '@apollo/client'

const SUCCESS_STORY_FIELDS = gql`
  fragment SuccessStoryFields on SuccessStoryType {
    author {
      id
      fullName
      getAvatar {
        photo
      }
    }
    id
    coverImage
    featuredArticleDescription
    title
    description
    fullName
    score
    storyAsHtml
    withWhiteImageBG
    slug
    platform {
      id
      title
    }
    tableOfContent {
      slug
      title
    }
    isUsedInSection
    getCoverImage
    studentsLikeYou {
      id
      fullName
      coverImage
      score
      description
      slug
      title
    }
  }
`

const STORYTELLER_ITEM_FIELDS = gql`
  fragment StorytellerItemFields on SuccessStoryType {
    id
    coverImage
    featuredArticleDescription
    title
    description
    fullName
    score
    slug
    getCoverImage
  }
`

const SUCCESS_STORY_SECTION_FIELDS = gql`
  ${SUCCESS_STORY_FIELDS}
  fragment SuccessStorySectionFields on SuccessStorySectionType {
    id
    title
    description
    platform {
      id
      title
    }
    successStory {
      ...SuccessStoryFields
    }
    successStoryIds
  }
`

export const FIND_ALL_SUCCESS_STORIES = gql`
  ${SUCCESS_STORY_FIELDS}
  query findAllSuccessStory($query: SuccessStoryQueryInput!) {
    findAllSuccessStory(query: $query) {
      count
      items {
        ...SuccessStoryFields
      }
    }
  }
`

export const FIND_ALL_SUCCESS_STORY_ARTICLES = gql`
  query findAllSuccessStoryArticles($query: SuccessStoryQueryInput!) {
    findAllSuccessStory(query: $query) {
      count
      items {
        id
        title
        updatedAt
        isUsedInSection
        author {
          id
          fullName
        }
        section {
          id
          title
        }
      }
    }
  }
`

export const CREATE_SUCCESS_STORY = gql`
  mutation createSuccessStory($createSuccessStoryInput: CreateSuccessStoryInput!) {
    createSuccessStory(createSuccessStoryInput: $createSuccessStoryInput) {
      id
      title
      description
      fullName
    }
  }
`

export const UPDATE_SUCCESS_STORY = gql`
  ${SUCCESS_STORY_FIELDS}
  mutation updateSuccessStory($updateSuccessStoryInputFieldName: UpdateSuccessStoryInput!) {
    updateSuccessStory(updateSuccessStoryInputFieldName: $updateSuccessStoryInputFieldName) {
      ...SuccessStoryFields
    }
  }
`

export const DELETE_SUCCESS_STORY = gql`
  mutation removeSuccessStory($removeSuccessStoryId: String!) {
    removeSuccessStory(id: $removeSuccessStoryId) {
      raw
      affected
    }
  }
`

export const FIND_ONE_SUCCESS_STORY = gql`
  ${SUCCESS_STORY_FIELDS}
  query findOneSuccessStory($id: String!) {
    findOneSuccessStory(id: $id) {
      ...SuccessStoryFields
    }
  }
`

export const FIND_ALL_SUCCESS_STORY_SECTIONS = gql`
  ${SUCCESS_STORY_SECTION_FIELDS}
  query findAllSuccessStorySection($query: SuccessStorySectionQueryInput!) {
    findAllSuccessStorySection(query: $query) {
      count
      items {
        ...SuccessStorySectionFields
      }
    }
  }
`

export const FIND_ONE_SUCCESS_STORY_SECTION = gql`
  ${SUCCESS_STORY_SECTION_FIELDS}
  query findOneSuccessStorySection($findOneSuccessStorySectionId: String!) {
    findOneSuccessStorySection(id: $findOneSuccessStorySectionId) {
      ...SuccessStorySectionFields
    }
  }
`

export const SEARCH_BY_STORYTELLER = gql`
  ${STORYTELLER_ITEM_FIELDS}
  query searchByStoryteller($searchString: String, $sectionId: String, $platformId: String) {
    searchByStoryteller(searchString: $searchString, sectionId: $sectionId, platformId: $platformId) {
      count
      items {
        ...StorytellerItemFields
      }
    }
  }
`

export const CREATE_SUCCESS_STORY_SECTION = gql`
  mutation createSuccessStorySection($createSuccessStorySectionInput: CreateSuccessStorySectionInput!) {
    createSuccessStorySection(createSuccessStorySectionInput: $createSuccessStorySectionInput) {
      id
      title
      description
      successStoryIds
    }
  }
`

export const UPDATE_SUCCESS_STORY_SECTION = gql`
  mutation updateSuccessStorySection($updateSuccessStorySectionInputFieldName: UpdateSuccessStorySectionInput!) {
    updateSuccessStorySection(updateSuccessStorySectionInputFieldName: $updateSuccessStorySectionInputFieldName) {
      id
      title
      description
      successStoryIds
    }
  }
`
